module.exports = __webpack_public_path__ + "img/69.7bf9f171.jpg";